import React from "react";
import { getImpersonatedUser, endImpersonationSession } from "@stadium/helpers/impersonation";
import styles from "./main.module.scss";

const ImpersonationBanner = ({ currentUsername }) => {
  const impersonatedUser = getImpersonatedUser();

  const handleClearImpersonation = () => {
    endImpersonationSession();
    window.location.reload();
  };

  if (!impersonatedUser) return null;

  return (
    <div className={styles.userAlertWrapper}>
      <div>
        <strong>({currentUsername})</strong> is impersonating as{" "}
        <strong>({impersonatedUser})</strong>.
        <a href="#" className={styles.closeLink} onClick={handleClearImpersonation}>
          Click here
        </a>
        to terminate this session.
      </div>
    </div>
  );
};

export default ImpersonationBanner;
